import "./style.css";
import { Flex, View } from "@adobe/react-spectrum";
import { Text } from "@react-spectrum/text";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/storeConfig";
import { formatLabel } from "../../../utils/utils";
import { CALL, CALLBACK } from "../../../constants/constants";
import { useCustomerAttributes } from "../../../hooks/useCustomerAttributes";
import { fixJson, formatTimestamp } from "../../../utils";

interface InteractionDetailsProps {
  type: "call" | "callback" | "voicemail";
}

const InteractionDetails = ({ type }: InteractionDetailsProps) => {
  const data = useSelector((state: RootState) => {
    if (type === CALL) return state.call;
    if (type === CALLBACK) return state.callback;
    return state.voicemail;
  });

  const agent = useSelector((state: RootState) => state.agent);
  const customerAttributes = data?.customer?.attributes || {};
  const agentBusinessAttributes = agent?.businessAttributes || [];

  const { groupedAttributes } = useCustomerAttributes({
    customerAttrs: customerAttributes,
    businessAttrs: agentBusinessAttributes,
    type: "detail",
  });

  const finalArray = groupedAttributes.map((group, i) => (
    <View key={`attribute-group-${i}`} marginTop={23}>
      <Flex direction="row" wrap="wrap" gap={16}>
        {group.map((attribute, index) => (
          <Flex
            direction="column"
            key={`attribute-${i + index}`}
            UNSAFE_style={{ flex: 1, minWidth: "31%", maxWidth: "31%" }}
          >
            <Text
              UNSAFE_className="call-detail-title"
              UNSAFE_style={{ wordBreak: "break-word" }}
            >
              {attribute.attributeName.toLowerCase() === "notes"
                ? "Transfer Notes"
                : formatLabel(attribute.attributeName)}
            </Text>
            {formatLabel(attribute.attributeName) ===
            "Aic Web Contact Monitored History" ? (
              <Text
                UNSAFE_className="call-detail-description"
                UNSAFE_style={{
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {fixJson(customerAttributes[attribute.attributeName]).map(
                  (detail: any, idx: number) => (
                    <Flex
                      justifyContent={"space-between"}
                      marginTop={4}
                      key={idx}
                    >
                      <Text>{detail.user}</Text>
                      <Text>{formatTimestamp(detail.TS)}</Text>
                    </Flex>
                  )
                )}
              </Text>
            ) : (
              <Text
                UNSAFE_className="call-detail-description"
                UNSAFE_style={{
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {customerAttributes[attribute.attributeName]}
              </Text>
            )}
          </Flex>
        ))}
      </Flex>
    </View>
  ));

  const heading =
    type === CALL
      ? "Call Details"
      : type === CALLBACK
      ? "Callback Details"
      : "Voicemail Details";

  return (
    <View
      borderColor="gray-200"
      borderWidth="thin"
      flexGrow={1}
      backgroundColor="gray-100"
      height="100%"
    >
      <Flex direction="row" width="100%" height="100%">
        <View
          width={
            type === CALL &&
            (!data?.isSilentMonitor || data?.self?.direction !== "OUTBOUND")
              ? "100%"
              : type === CALL
              ? "65%"
              : "100%"
          }
          padding={32}
        >
          <Flex
            direction="column"
            UNSAFE_className="call-detail-wrapper"
            height="100%"
          >
            <Flex height="60%" direction="column">
              <Text UNSAFE_className="customer-detail-heading">{heading}</Text>
              <View>{finalArray}</View>
            </Flex>
          </Flex>
        </View>
      </Flex>
    </View>
  );
};

export default InteractionDetails;
